"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tenantStore = tenantStore;
var _redux = require("redux");
var _reduxSaga = _interopRequireDefault(require("redux-saga"));
var _reducers = _interopRequireDefault(require("./reducers"));
var _sagas = _interopRequireDefault(require("./sagas"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @flow

var sagaMiddleware = (0, _reduxSaga.default)();
var middlewares = [sagaMiddleware];
function tenantStore(initialState) {
  var store;
  if (window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"]) {
    store = (0, _redux.createStore)(_reducers.default, initialState, window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"](_redux.applyMiddleware.apply(void 0, middlewares)));
  } else {
    store = (0, _redux.createStore)(_reducers.default, initialState, _redux.applyMiddleware.apply(void 0, middlewares));
  }
  sagaMiddleware.run(_sagas.default);
  return store;
}